var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getValue from './getValue';
import getColReferenceDataArray from './getColReferenceDataArray';
import getFullTable from 'src/utils/entityOperations/getFullTable';
import fetchAllRecords from 'src/utils/entityOperations/fetchAllRecords';
import fromStringToIsoDate from 'src/utils/dateOperations/fromStringToIsoDate';
import dateToISODate from 'src/utils/dateOperations/dateToISODate';
export default function openValueSelectorDialog(cellProps, valueChangeCallback, ctx) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { row, col } = cellProps;
        if (!(col.isTime || col.isDate || col.references || col.complexlyReferences || (col.cellReferences && col.cellReferences(cellProps))))
            return void 0;
        let componentParamsToPass = {
            currentValueParam: null,
            referredData: null,
            handleSelectorValueSelection: () => ({}),
            cellProps: null,
            componentProps: undefined
        };
        if (col.complexlyReferences) {
            const cr = col.complexlyReferences;
            const rows = typeof cr.table === 'string' ? getFullTable(cr.table) : cr.table;
            const labelGetter = (cr.type === 'labelGetter')
                ? cr.labelGetter
                : (r) => r[cr.reference_value_field];
            componentParamsToPass.referredData = rows.map(r => ({ id: r[cr.reference_value_field], name: labelGetter(r) }));
        }
        else if (col.references && Array.isArray(col.references)) {
            // @ts-ignore
            componentParamsToPass.referredData = col.references;
        }
        else if (col.references && typeof col.references === 'function') {
            componentParamsToPass.referredData = getColReferenceDataArray(col.references, ctx, cellProps);
        }
        else if (col.cellReferences && col.cellReferences(cellProps)) {
            componentParamsToPass.referredData = col.cellReferences(cellProps);
        }
        else if (col.references && typeof col.references === 'string') {
            let data = getFullTable(col.references);
            debugger;
            if (!data || data.length === 0) {
                data = yield fetchAllRecords(col.references);
            }
            if (data.length > 0) {
                componentParamsToPass.referredData = data;
            }
            else {
                debugger;
                return void 0;
            }
        }
        else if (col.isDate) {
            componentParamsToPass.referredData = null;
        }
        else if (col.isTime) {
            const timePickerDialogParams = {
                componentProps: col.isTimeComponentProps
            };
            componentParamsToPass = Object.assign(Object.assign({}, componentParamsToPass), timePickerDialogParams);
        }
        else {
            debugger;
            return void 0;
        }
        let curValue = getValue(col, row);
        if (curValue === null || curValue === undefined)
            curValue = '';
        componentParamsToPass.currentValueParam = Array.isArray(curValue) ? String(curValue) : String(curValue);
        componentParamsToPass.handleSelectorValueSelection = (x) => valueChangeCallback(x, cellProps);
        componentParamsToPass.cellProps = cellProps;
        let dialogType = 'mainLookupDialog';
        if (col.isDate) {
            dialogType = 'datePicker';
        }
        else if (col.isTime) {
            dialogType = 'timePicker';
        }
        else if (col.preferredSelectorDialogType) {
            dialogType = col.preferredSelectorDialogType;
        }
        else {
            dialogType = Object.keys(((_a = componentParamsToPass === null || componentParamsToPass === void 0 ? void 0 : componentParamsToPass.referredData) === null || _a === void 0 ? void 0 : _a[0]) || {}).includes('parent_id') ? 'treeLookup' : 'mainLookupDialog';
        }
        if (dialogType === 'treeLookup') {
            const treeParams = {
                currentValueParam: componentParamsToPass.currentValueParam,
                dataParam: componentParamsToPass.referredData || [],
                handleSelectorValueSelection: componentParamsToPass.handleSelectorValueSelection,
                tickStrategy: 'strict'
            };
            ctx.$refs[dialogType].openDialog(treeParams);
        }
        else if (dialogType === 'mainLookupDialog') {
            const mainLookupParams = {
                currentValueParam: componentParamsToPass.currentValueParam,
                dataParam: componentParamsToPass.referredData || [],
                handleSelectorValueSelection: componentParamsToPass.handleSelectorValueSelection
            };
            ctx.$refs[dialogType].openDialog(mainLookupParams);
        }
        else if (dialogType === 'datePicker') {
            const datePickerParams = {
                currentValueParam: fromStringToIsoDate(componentParamsToPass.currentValueParam) || dateToISODate(new Date()),
                handleSelectorValueSelection: componentParamsToPass.handleSelectorValueSelection
            };
            ctx.$refs[dialogType].openDialog(datePickerParams);
        }
        else if (dialogType === 'timePicker') {
            const timePickerParams = {
                currentValueParam: componentParamsToPass.currentValueParam || '00:00',
                handleSelectorValueSelection: componentParamsToPass.handleSelectorValueSelection
            };
            ctx.$refs[dialogType].openDialog(timePickerParams);
        }
    });
}
